import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './shared/main/main.component';
import { OnboardingGuard } from './shared/onboarding.guard';
import { AuthGuard } from './shared/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'cambio-contrasenia',
    loadChildren: () => import('./recovery-password/recovery-password.module').then(m => m.RecoveryPasswordModule)
  },
  {
    path: 'send-email',
    loadChildren: () => import('./send-email/send-email.module').then(m => m.SendEmailModule)
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'configuraciones',
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'calculadora',
        loadChildren: () => import('./calculator/calculator.module').then(m => m.CalculatorModule)
      },
      {
        path: 'documentos',
        loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule)
      },
      {
        path: 'entrenamiento',
        loadChildren: () => import('./entrenamiento/entrenamiento.module').then(m => m.EntrenamientoModule)
      },
      {
        path: 'asistente',
        loadChildren: () => import('./ia-assistant/ia-assistant.module').then(m => m.IaAssistantModule)
      },
      {
        path: 'planes',
        loadChildren: () => import('./plans/plans.module').then(m => m.PlansModule)
      },
      {
        path: 'productos',
        loadChildren: () => import('./products/products.module').then(m => m.ProductsModule)
      },
      {
        path: 'pastillas-kaizen',
        loadChildren: () => import('./tablets/tablets.module').then(m => m.TabletsModule)
      },
      {
      path: 'asesores',
        loadChildren: () => import('./asesor/asesor.module').then(m => m.AsesorModule)
      },
      {
        path: 'clientes',
        loadChildren: () => import('./asesor/asesor.module').then(m => m.AsesorModule)
      }
    ]
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule)
  },
  {
    path: '**',
    redirectTo: ''
  },
  {
    path: 'logout',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
